import Cookies from 'js-cookie';

const cookiesNames = {
  isCookiesPopup: 'COOKIES_POPUP',
  amplitudeAnalytics: 'AMPLITUDE_ANALYTICS',
  googleAnalytics: 'GOOGLE_ANALYTICS'
};

// js-cookie 3 dropped getJSON; cookies written by v2 are JSON-encoded
const getJSONCookie = key => {
  const value = Cookies.get(key);
  if (value === undefined) {
    return undefined;
  }
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

const state = {
  isCookiesDialog: false,
  isCookiesPopup: getJSONCookie(cookiesNames.isCookiesPopup),
  amplitudeAnalytics: getJSONCookie(cookiesNames.amplitudeAnalytics),
  googleAnalytics: getJSONCookie(cookiesNames.googleAnalytics)
};

const getters = {
  getCookiesDialog: state => state.isCookiesDialog,
  getCookiesPopup: state => {
    if (state.isCookiesPopup === undefined) {
      return true;
    }

    return state.isCookiesPopup;
  },
  isGoogleAnalyticsCookies: state =>
    state.googleAnalytics === undefined || state.googleAnalytics
};

const mutations = {
  updateCookiesDialogs(state, payload) {
    state.isCookiesDialog = payload;
  },
  updateCookiesPopup(state, payload) {
    Cookies.set(cookiesNames.isCookiesPopup, payload);
    state.isCookiesPopup = payload;
  },
  updateGoogleAnalytics(state, payload) {
    Cookies.set(cookiesNames.googleAnalytics, payload);
    state.googleAnalytics = payload;
  }
};

const actions = {
  setCookiesDialogs({ commit }, value) {
    commit('updateCookiesDialogs', value);
  },
  setCookiesPopup({ commit }, value) {
    commit('updateCookiesPopup', value);
  },
  setGoogleAnalytics({ commit }, value) {
    commit('updateGoogleAnalytics', value);
  },
  closeCookieWidget({ commit }) {
    commit('updateCookiesPopup', false);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
